import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Attachment, DomainType } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;
import { catchError, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThumbnailService {

    constructor(
        private http: HttpClient
    ) { }

    public getThumbnailUrl(attachment: Attachment): Observable<string> {

        let path: string = null;

        if (!attachment) return of(null);

        const extension = attachment.path?.split('.').pop()?.toLowerCase();
        if (['json', 'msg', 'xml', 'eml'].includes(extension)) return of(null);

        let filename: string = null;

        switch (attachment.type) {
            case 'Form':
                const { domain, tenant } = ConfigService.environment;

                if (attachment?.path?.endsWith('pdf')) {
                    path = attachment.path;
                    filename = `${attachment._id}.pdf`;
                } else if ((attachment.data as string)?.endsWith('pdf')) {
                    path = attachment.data;
                } else {
                    path = `https://pdf.${domain}/pdf?url=${encodeURI(`https://${tenant}.${domain}/forms/${attachment.path}`)}`;
                    filename = `${attachment._id}.pdf`;
                }
                break;

            default:
                path = attachment.path;
                break;
        }

        if (!path) return of(null);

        const safeApi = [DomainType.ClientPortal, DomainType.ContractorPortal].includes(ConfigService.environment.domainType as any)
            ? 'https://__tenant__/api/attachments/thumbnail'
            : '/api/attachments/thumbnail';

        return this.http
            .get(safeApi,
                {
                    responseType: 'text',
                    params: filename
                        ? { bloburi: path, filename: filename, attachmentId: attachment?._id }
                        : { bloburi: path, attachmentId: attachment?._id }
                }
            )
            .pipe(
                catchError(error => {
                    console.error(error);
                    return of(null);
                })
            );
    }

}